module.exports = __webpack_public_path__ + "img/galeria-plantas-ornamentales1.26c623af.jpg";